<div id="billingcycletoggle" style="background-color: white;">
  <webu-stepper-heading
    id="stepper1"
    [steps]="getSteps()"
    [currentStep]="getCurrentStep()"
    [returnState]="getReturnState()"
    [isUpdatePlanComponent]="isUpdatePlanComponent"
    trackingString="shop:update plan:billing:link:my plans"
  ></webu-stepper-heading>
  <div class="container">
    <div class="row">
      <div class="float-left col-12" *ngIf="offers.length > 1">
        <span class="float-left gb-headline1 mt-9"
          >Select billing for your plans</span
        >
      </div>
    </div>
    <div class="row" *ngFor="let billingDetails of offers">
      <div class="float-left col-12" *ngIf="offers.length === 1">
        <span class="float-left gb-headline1 mt-9"
          >Select your billing for {{ billingDetails.displayName }}</span
        >
      </div>
    </div>
    <div class="row mb-1 toggle mt-5">
      <div class="container ng-scope" style="padding-left: 0px">
        <p
          id="p-annual-message"
          *ngIf="saveWithAnnualMessage && !isAnnual"
          class="gb-body2"
        >
          {{ saveWithAnnualMessage }}
        </p>
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <label
            *ngFor="let item of toggleOptions; index as index"
            id="label-option{{ index }}"
            class="btn gb-secondary-button border-gray"
            [ngClass]="{active: isAnnual === !!index}"
            (click)="setValue($event, !!index) ; trackingService.fireProp10Tracking('shop:update plan:billing:button:'+ item,'','',item,'' ,true)"
            (keyup.enter)="setValue($event, !!index)"
            tabindex="0"
          >
            <input
              type="radio"
              name="options"
              id="input-option{{ index }}"
              tabindex="-1"
              autocomplete="off"
              [checked]="isAnnual === !!index"
            />
            <div id="div-option{{ index }}">{{ item }}</div>
          </label>
        </div>
      </div>
    </div>
    <div
      *ngFor="let billingDetails of offers; let i = index"
      [ngClass]="i === 0 ? 'bordernone' : 'upperborder'"
    >
      <div class="row mt-2">
        <div class="float-left col-12">
          <span class="float-left gb-body1 bold">{{
            billingDetails.displayName
          }}</span>
        </div>
      </div>
      <div class="row mt-2" *ngIf="!isAnnual">
        <div class="float-left col-12 gb-body3">
          <span class="float-left">{{
            billingDetails.offer.annualDiscountTaglineCopy
          }}</span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <span class="gb-bold1 d-inline-block">
            {{ billingDetails.price.customerFinalPrice | currency }}
          </span>
          <span
          *ngIf="
          billingDetails.price?.customerFinalPrice !==
          billingDetails.price?.retailPrice"
            class="gb-body2 strike-through gray-text">
            {{ billingDetails.price.retailPrice | currency }}
          </span>
          <div class="gb-body3 d-inline-block">
            <span
              *ngIf="!isAnnual"
              translate="plan_details_perMonth"
              [translate]="'plan_details_perMonth'"
            ></span>
            <span
              *ngIf="isAnnual"
              translate="plan_details_perYear"
              [translate]="'plan_details_perYear'"
            ></span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="float-left col-12 mb-0 gb-body3">
          <a
            class="float-left pl-0 pr-0 pb-0 mb-0 mt-1 mb-3 firstlet-cap automation-disclosure-link"
            gb-body3
            data-toggle="modal"
            data-target="#exampleModal"
            (click)="trackingService.fireProp10Tracking('shop:update plan:billing:link:'+ billingDetails.displayName,'','',billingDetails.displayName,'' ,true); openServicemainModal(i)"
            >About {{ billingDetails.displayName }}
          </a>
        </div>
      </div>
      <div class="row" *ngIf="billingDetails.disclosure">
        <div class="float-left col-12 gb-body3">
          <a
            class="float-left pl-0 pr-0 pb-0 mb-0 mb-8 firstlet-cap automation-disclosure-link"
            gb-body3
            data-toggle="modal"
            data-target="#exampleModal"
            (click)="trackingService.fireProp10Tracking('shop:update plan:billing:link:disclosures','','','disclosures','' ,true); openDisclosureModal(billingDetails)"
            >Disclosures</a
          >
        </div>
      </div>
    </div>
    <div class="row" style="padding-bottom: 150px">
      <div class="col p-0">
        <hr class="cit" />
        <webu-chat-footer
          trackingString="shop:update plan:billing:button:message us">
        </webu-chat-footer>
      </div>
    </div>
    <div class="row" style="padding-bottom: 150px">
      <div class="col p-0">
        <hr class="cit" />
        <webu-payment-footer
          *ngIf="footerObj"
          trackingString="shop:update plan:billing:button:message us"
          planStatus="update plan"
          continueButtonSubString="shop:update plan:"
          footerString=":footer"
          buttonName="Continue"
          [planName]="footerObj.selectedProductName"
          [planDisclosure]="footerObj.selectedProductDisclosure"
          [isMonthly]="!isAnnual"
          [planCount]="footerObj.planCount"
          (continueButton)="onFooterButtonClick()"
          [price]="footerObj.price"
          [priceDisclosure]="footerObj.priceDisclosure"
          [selectedBYO]="footerObj.selectedBYO"
          [residueBYO]="footerObj.residueBYO"
          [offerIds]="footerObj.offerIds"
          [doHideFrequencyText]="false"
        ></webu-payment-footer>
      </div>
    </div>
  </div>
</div>
